import { gql } from '@apollo/client'

export const SINGLE_PRODUCT_POINT_CLOUD_FRAGMENT = gql`
  fragment SingleProductPointCloud on SingleProductPointCloud {
    __typename
    id
    labels
    centroids
    predicted
    bucketFileName
    saved
    created
  }
`
